import { CmsApiImageGalleryBlockData } from 'modules/cms/api/types/CmsApiImageGallery';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpImageGalleryBlock } from './CmsAmpImageGalleryBlock';
import { CmsImageGalleryBlock } from './CmsImageGalleryBlock';

export const CmsImageGalleryBlockMapping: CmsBlockMapping<CmsApiImageGalleryBlockData> =
  {
    invariant: [
      {
        prop: 'images',
        msg: 'Images required for Image Gallery',
      },
    ],
    width: CmsBlockWidth.GRID,
    Component: CmsImageGalleryBlock,
    AmpComponent: CmsAmpImageGalleryBlock,
  };
